import React from 'react';
import styled from 'styled-components';
import { Body5, Container, H1 } from '@ui';
import { selectLightTheme } from '@utils/themes';
import { SplashSectionWrapper } from './styles';

const TestimonialsWrapper = styled.div`
  * {
    color: ${({ theme }) => selectLightTheme(theme).text};
  }
`;
const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 16px;

  max-width: 1400px;

  @media (max-width: 960px) {
    display: grid;
    grid-template-columns: auto;
    gap: 16px;
  }
`;
const TrustedByHeadingWrapper = styled.div`
  padding-bottom: 36px;
  text-align: left;
  width: 100%;

  h1 {
    font-size: 48px;
    line-height: 64px;
    letter-spacing: -3px;
  }

  @media (max-width: 710px) {
    h1 {
      font-size: 24px;
      line-height: 32px;
      letter-spacing: -1px;
    }
  }
`;
const TestimonialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  padding: 16px;

  background: ${({ theme }) => selectLightTheme(theme).componentNoOpacity};
  border: 1px solid ${({ theme }) => selectLightTheme(theme).border};
  border-radius: 5px;

  * {
    color: ${({ theme }) => selectLightTheme(theme).text} !important;
  }
`;
const PersonBio = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  gap: 24px;

  padding: 24px 0 0 0;
`;
const LogoWrapper = styled.div``;
const PersonBioText = styled.div``;
const TestimonialQuoteWrapper = styled.div`
  * {
    font-size: 18px;
    line-height: 24px;
    font-style: italic;
  }

  @media (max-width: 960px) {
    * {
      font-size: 14px;
      line-height: 18px;
    }
  }
`;
const AnnalyLogoWrapper = styled.div``;
const PolpoLogoWrapper = styled.div``;
const LinmarLogoWrapper = styled.div``;
const CWLogoWrapper = styled.div`
  svg {
    height: 40px;
    width: 164px;
  }
`;

function TrustedBySection() {
  return (
    <TrustedByHeadingWrapper>
      <H1>Trusted by firms with $500bn+&nbsp;in&nbsp;AUM</H1>
    </TrustedByHeadingWrapper>
  );
}

function BlankLogo() {
  return <Container style={{ height: '50px' }} />;
}

function AnnalyLogo() {
  const height = 28;
  const width = 148;
  return (
    <AnnalyLogoWrapper>
      <img src="/images/logos/annaly_b.png" width={width} height={height} alt="logo" />
    </AnnalyLogoWrapper>
  );
}

function CWLogo() {
  return (
    <CWLogoWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 245.6 25.2"
      >
        <g id="Layer_2_1_">
          <g id="Layer_1-2">
            <path
              class="st0"
              d="M12.9,19.7c3.1,0,5.1-1.8,5.1-2.4l2.6,4.1h-0.1c-1.3,0-3.2,2.3-8.1,2.3C6.7,23.9,1.9,19.3,1.7,13.6    c0-0.1,0-0.3,0-0.4C1.6,7.4,6.2,2.6,12,2.5c0.1,0,0.3,0,0.4,0c4.9,0,6.8,2.3,8.1,2.3h0.1L18,8.9c0-0.6-2.1-2.4-5.1-2.4    c-3.6-0.1-6.6,2.6-6.7,6.2c0,0.1,0,0.3,0,0.4c-0.1,3.5,2.6,6.5,6.1,6.6C12.6,19.7,12.7,19.7,12.9,19.7z"
            ></path>
            <path
              class="st0"
              d="M23.6,13.1c0-5.8,4.7-10.6,10.6-10.6c0.1,0,0.1,0,0.2,0C40.3,2.5,45,7.3,45,13.1c0,5.9-4.7,10.6-10.6,10.6    c0,0,0,0,0,0c-5.8,0.1-10.6-4.4-10.8-10.3C23.6,13.4,23.6,13.2,23.6,13.1z M40.6,13.1c0.2-3.5-2.5-6.5-5.9-6.7s-6.5,2.5-6.7,5.9    c0,0.2,0,0.5,0,0.7c-0.2,3.5,2.5,6.5,5.9,6.7c3.5,0.2,6.5-2.5,6.7-5.9C40.6,13.6,40.6,13.4,40.6,13.1z"
            ></path>
            <path
              class="st0"
              d="M64.9,7c-0.2-0.2-0.8-0.3-2.1-0.3h-4.7v13.4c0,1.9,0,2.9,0.4,3.3h-5.1c0.4-0.4,0.4-1.4,0.4-3.3V6.7h-4.7    c-1.3,0-1.9,0.1-2.1,0.3V2.5c0.2,0.2,0.8,0.3,2.1,0.3h13.6c1.3,0,1.9-0.1,2.1-0.3V7H64.9z"
            ></path>
            <path
              class="st0"
              d="M86.4,7c-0.2-0.2-0.8-0.3-2.1-0.3h-4.6v13.4c0,1.9,0,2.9,0.4,3.3H75c0.4-0.4,0.4-1.4,0.4-3.3V6.7h-4.7    c-1.3,0-1.9,0.1-2.1,0.3V2.5c0.2,0.2,0.8,0.3,2.1,0.3h13.6c1.3,0,1.9-0.1,2.1-0.3V7z"
            ></path>
            <path
              class="st0"
              d="M88,13.1c-0.1-6,4.6-10.9,10.6-11c6-0.1,10.9,4.6,11,10.6S105,23.6,99,23.7c-0.1,0-0.1,0-0.2,0    C93,23.8,88.2,19.2,88,13.4C88,13.3,88,13.2,88,13.1z M105.1,13.1c0.2-3.5-2.5-6.5-5.9-6.7c-3.5-0.2-6.5,2.5-6.7,5.9    c0,0.2,0,0.5,0,0.7c-0.2,3.5,2.5,6.5,5.9,6.7c3.5,0.2,6.5-2.5,6.7-5.9C105.1,13.6,105.1,13.4,105.1,13.1z"
            ></path>
            <path
              class="st0"
              d="M114.6,6.1c0-1.9,0-2.9-0.4-3.3h5.3c-0.1,0.1-0.2,0.3-0.2,0.5l9.8,13.3V6.1c0-1.9,0-2.9-0.4-3.3h5.1    c-0.4,0.4-0.4,1.4-0.4,3.3v14c0,1.9,0,2.9,0.4,3.3h-5.2c0.1-0.2,0.2-0.4,0.2-0.6l-10-13.5v10.8c0,1.9,0,2.9,0.4,3.3h-5.1    c0.4-0.4,0.4-1.4,0.4-3.3C114.5,20.1,114.6,6.1,114.6,6.1z"
            ></path>
            <path
              class="st1"
              d="M155.9,4.2c-0.1,0.1-0.1,0.2-0.1,0.4c0.2,0.8,0.4,1.6,0.7,2.3l3.4,9.7l3.9-11c0.3-0.7,0.5-1.4,0.6-2.2    c0-0.2-0.1-0.4-0.2-0.5h5.7c-0.5,0.3-1,1.3-1.7,3.1l-5.3,14.4c-0.4,0.9-0.7,1.8-0.9,2.7c0,0.2,0.1,0.3,0.1,0.4H158    c0.1-0.1,0.1-0.2,0.1-0.4c-0.2-0.9-0.5-1.8-0.9-2.7l-3.4-9.6l-3.4,9.6c-0.4,0.9-0.7,1.8-0.9,2.7c0,0.1,0,0.3,0.1,0.4h-4.1    c0.1-0.1,0.1-0.2,0.1-0.4c-0.2-0.9-0.5-1.8-0.9-2.7L139.4,6c-0.6-1.8-1.1-2.8-1.7-3.1h5.7c-0.2,0.1-0.2,0.3-0.2,0.5    c0.1,0.8,0.3,1.5,0.6,2.2l3.9,10.9l3.4-9.6c0.3-0.7,0.5-1.5,0.7-2.3c0-0.2,0-0.3-0.1-0.4L155.9,4.2z"
            ></path>
            <path
              class="st1"
              d="M171.7,13.1c-0.1-6,4.6-10.9,10.6-11c6-0.1,10.9,4.6,11,10.6s-4.6,10.9-10.6,11c-0.1,0-0.1,0-0.2,0    c-5.8,0.1-10.7-4.5-10.8-10.4C171.7,13.3,171.7,13.2,171.7,13.1z M188.8,13.1c0.2-3.5-2.5-6.5-5.9-6.7c-3.5-0.2-6.5,2.5-6.7,5.9    c0,0.2,0,0.5,0,0.7c-0.2,3.5,2.5,6.5,5.9,6.7c3.5,0.2,6.5-2.5,6.7-5.9C188.8,13.6,188.8,13.4,188.8,13.1z"
            ></path>
            <path
              class="st1"
              d="M197.4,13.1c-0.1-6,4.6-10.9,10.6-11c6-0.1,10.9,4.6,11,10.6s-4.6,10.9-10.6,11c-0.1,0-0.1,0-0.2,0    c-5.8,0.1-10.7-4.5-10.8-10.4C197.4,13.3,197.4,13.2,197.4,13.1z M214.5,13.1c0.2-3.5-2.5-6.5-5.9-6.7c-3.5-0.2-6.5,2.5-6.7,5.9    c0,0.2,0,0.5,0,0.7c-0.2,3.5,2.5,6.5,5.9,6.7c3.5,0.2,6.5-2.5,6.7-5.9C214.5,13.6,214.5,13.4,214.5,13.1z"
            ></path>
            <path
              class="st1"
              d="M224.4,6.1c0-1.9,0-2.9-0.4-3.3h7.6c6.9,0,12.5,3.6,12.5,10.3s-5.6,10.3-12.5,10.3H224    c0.4-0.4,0.4-1.4,0.4-3.3V6.1z M231.6,6.6h-2.9v13h2.9c4.6,0,8.1-2.1,8.1-6.5S236.1,6.6,231.6,6.6z"
            ></path>
          </g>
        </g>
      </svg>
    </CWLogoWrapper>
  );
}

function IIAwardLogo() {
  const height = 50;
  const width = 180;
  return (
    <PolpoLogoWrapper>
      <img src="/images/logos/iiAward.png" width={width} height={height} alt="logo" />
    </PolpoLogoWrapper>
  );
}

function PolpoLogo() {
  const height = 38;
  const width = 168;
  return (
    <PolpoLogoWrapper>
      <img src="/images/logos/polpo_b.png" width={width} height={height} alt="logo" />
    </PolpoLogoWrapper>
  );
}

function LinmarLogo() {
  const height = 48;
  const width = 48;
  return (
    <LinmarLogoWrapper>
      <img src="/images/logos/linmar_b.png" width={width} height={height} alt="logo" />
    </LinmarLogoWrapper>
  );
}

const Testimonial = ({ text, logo, name, company }) => {
  return (
    <TestimonialWrapper>
      <TestimonialQuoteWrapper>
        <Body5>{text}</Body5>
      </TestimonialQuoteWrapper>
      <PersonBio>
        <LogoWrapper>{logo}</LogoWrapper>
        <PersonBioText>
          <Container>
            <Body5>{name}</Body5>
          </Container>
          <Container>
            <Body5>{company}</Body5>
          </Container>
        </PersonBioText>
      </PersonBio>
    </TestimonialWrapper>
  );
};

/*
<Testimonial
              name={'Jeff Wang, MD, Head of Mortgage Analytics'}
              company={'Annaly Capital Management'}
              text={`“Our team has been impressed with how responsive and helpful Tornado AI has been.  They built several custom features for us and typically respond to questions within minutes.  We’re able to save hours on repetitive tasks, with more thorough and accurate research than would be possible by hand.”`}
              logo={<AnnalyLogo />}
            />
*/
export const Testimonials = () => {
  return (
    <SplashSectionWrapper>
      <TestimonialsWrapper>
        <TrustedBySection />
        <Container>
          <TestimonialsGrid>
            <Testimonial
              name={<>Alexander Shing, Chairman&nbsp;&&nbsp;CEO</>}
              company={'Cottonwood Management'}
              text={`"Tornado’s accuracy and transparency give us a high level of confidence in our analytics. Every result is fully auditable and clearly sourced, freeing our team to focus on strategic decision-making rather than manual data reconciliation. The platform’s flexibility, combined with the Tornado team’s proactive support, made integration seamless. We noticed immediate time savings and efficiencies from the outset. For financial institutions seeking to elevate their research and decision-making, Tornado is a highly compelling solution."`}
              logo={<CWLogo />}
            />
            <Testimonial
              name={<>Dan McNamara, Founder&nbsp;and&nbsp;CEO</>}
              company={'Polpo Capital Management'}
              text={`"Tornado AI allows our team to effortlessly query dense hundred-plus page offering documents in seconds to find the data important to our investment process. The efficiency and hours saved allow us to devote more time to other critical tasks."`}
              logo={<PolpoLogo />}
            />
            <Testimonial
              name={'Co-President'}
              company={<>Multi-Billion Dollar Equity Long/Short&nbsp;Hedge&nbsp;Fund</>}
              text={`“Tornado AI helped accelerate a key part of our research process from around two days of repetitive, human-intensive work to just a few hours.  This frees up our team to make informed decisions faster.  It has the potential to fundamentally transform our investment process.”`}
              logo={<IIAwardLogo />}
            />
            <Testimonial
              name={<>Albert Saad, Analyst</>}
              company={'Linmar Capital'}
              text={`“Tornado has upgraded my research process as a hedge fund analyst. It allows me to quickly summarize filings, get up to speed on new companies,‬ ‭and gain industry insights with ease. The Tornado team is incredibly helpful‬ ‭and always receptive to feedback, continuously adding new features that‬ enhance the platform. With the time saved and the enhanced capabilities‬ Tornado provides, I can’t imagine going back to traditional methods. Any hedge fund that doesn't start using AI soon will quickly fall behind."`}
              logo={<LinmarLogo />}
            />
          </TestimonialsGrid>
        </Container>
      </TestimonialsWrapper>
    </SplashSectionWrapper>
  );
};
